<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { fireReaction, reactionsState } from "../../../states/reactionsState";
import ReactionIcon24 from "../../icons/ReactionIcon24.vue";
// import { getFloatingReaction } from "../../../states/ui";

defineProps<{
  recorder?: boolean;
}>();

const gradientClass = computed(() => {
  const n = Math.max(Math.min(reactionsState.currentCount, 10), 1) || 1;
  return `gradient-${n}`;
});
const pulse = ref(false);
watch(
  () => reactionsState.currentCount,
  (next) => {
    if (next > 10) {
      pulse.value = true;
    } else if (next === 0) {
      pulse.value = false;
    }
  },
);
// const floatingReaction = props.recorder ? ref(false) : getFloatingReaction();
</script>
<template>
  <div
    class="reaction-button-wrapper"
    :class="{
      // floating: floatingReaction,
      recorder: !!recorder,
      recorderActive: !!recorder && reactionsState.currentCount > 0,
    }"
  >
    <button
      class="reaction-button"
      :class="{
        active: reactionsState.currentCount > 0,
        [gradientClass]: reactionsState.currentCount > 0,
        pulse,
      }"
      @click="fireReaction"
    >
      <ReactionIcon24 />
      <span v-if="reactionsState.currentCount" class="counter">{{
        reactionsState.currentCount
      }}</span>
    </button>
  </div>
</template>

<style scoped>
.reaction-button-wrapper {
  width: max-content;
  height: max-content;
  transform: translateY(0px);
  transition: transform 0.3s ease-in-out;
}

.reaction-button {
  width: 44px;
  height: 44px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  background: var(--bottom-btn-off-bg-regular);
  color: var(--bottom-btn-off-content-regular);
  backdrop-filter: blur(2px);
  border-radius: 50px;
  border: none;
  cursor: pointer;
  color: white;
  outline: none;
  user-select: none;
}

.reaction-button-wrapper.floating {
  transform: translateY(-76px) scale(1);
}

.reaction-button-wrapper.recorder {
  transform: translateY(52px) scale(1);
}

.reaction-button-wrapper.recorderActive {
  transform: translateY(0px) scale(1);
}

.reaction-button:active {
  outline: none;
}

.reaction-button.active {
  min-width: 60px;
  width: fit-content;
  padding-right: 8px;
  border-radius: 26px;
}

.reaction-button:hover:not(.active) {
  background-color: var(--bottom-btn-off-bg-hover);
  color: var(--bottom-btn-off-content-hover);
}

.reaction-button .counter {
  font-family: Open Sans;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 14px;
  min-width: 18px;
  text-align: center;
}

.reaction-button.active.gradient-1 {
  background: radial-gradient(50% 50% at 50% 50%, #ff9500 0%, #ff6a00 100%);
}

.reaction-button.active.gradient-2 {
  background: radial-gradient(50% 50% at 50% 50%, #ff9500 0%, #ff6a00 100%);
}

.reaction-button.active.gradient-3 {
  background: radial-gradient(50% 50% at 50% 50%, #ff9800 0%, #f55600 100%);
}

.reaction-button.active.gradient-4 {
  background: radial-gradient(50% 50% at 50% 50%, #ff9800 0%, #f55600 100%);
}

.reaction-button.active.gradient-5 {
  background: radial-gradient(50% 50% at 50% 50%, #ff9800 0%, #ef400a 100%);
}

.reaction-button.active.gradient-6 {
  background: radial-gradient(50% 50% at 50% 50%, #ff9800 0%, #ef400a 100%);
}

.reaction-button.active.gradient-7 {
  background: radial-gradient(50% 50% at 50% 50%, #ff9800 0%, #f52213 100%);
}

.reaction-button.active.gradient-8 {
  background: radial-gradient(50% 50% at 50% 50%, #ff9800 0%, #f52213 100%);
}

.reaction-button.active.gradient-9 {
  background: radial-gradient(50% 50% at 50% 50%, #ff9800 0%, #f20e0e 100%);
}

.reaction-button.active.gradient-10 {
  background: radial-gradient(50% 50% at 50% 50%, #ff9800 0%, #f20e0e 100%);
}

.pulse {
  animation: breathe 1.6s ease-in-out infinite;
}

.pulse::after {
  content: "";
  z-index: -1;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  border-radius: 26px;
  background: radial-gradient(50% 50% at 50% 50%, #ff9800 0%, #f44336 100%);
  opacity: 0.6;
  animation: ripple 1.6s ease-out infinite;
}

@keyframes breathe {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.04);
  }
}

@keyframes ripple {
  0% {
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    border-radius: 26px;
    opacity: 0.6;
  }
  70% {
    left: -12px;
    top: -12px;
    bottom: -12px;
    right: -12px;
    border-radius: 32px;
    opacity: 0;
  }
  100% {
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    border-radius: 32px;
    opacity: 0;
  }
}
</style>
